// extracted by mini-css-extract-plugin
module.exports = {"cityclass":"IndexDom_cityclass__yvsqX","book":"IndexDom_book__9gE4M"};